"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _filterUtils = require("@nicbase/filter-utils");

var _hooks = require("@nicbase/hooks");

var _types = require("@nicbase/types");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var PoiFilter = function PoiFilter(_ref) {
  var _poisData$pages$flat;

  var className = _ref.className,
      inputClassName = _ref.inputClassName,
      optionRenderer = _ref.optionRenderer,
      disabled = _ref.disabled,
      icon = _ref.icon,
      label = _ref.label,
      hideLabel = _ref.hideLabel,
      value = _ref.value,
      error = _ref.error,
      categoryIconFilters = _ref.categoryIconFilters,
      _onChange = _ref.onChange;

  var _useState = (0, _react.useState)(value ? null : ''),
      _useState2 = _slicedToArray(_useState, 2),
      query = _useState2[0],
      setQuery = _useState2[1];

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _usePortalPoisPaginat = (0, _hooks.usePortalPoisPaginated)({
    portalId: portalId,
    dynamicFilters: query === null ? (0, _filterUtils.equal)('poi.id', value, _types.FilterAttributeType.Integer).filterTree : (0, _filterUtils.and)(query.length > 0 ? (0, _filterUtils.like)('poi.name', query, _types.FilterAttributeType.String) : null, categoryIconFilters ? (0, _filterUtils.isNotIn)('poi.categoryIcon', categoryIconFilters, _types.FilterAttributeType.String) : null).filterTree,
    dynamicSorters: [{
      attributeName: 'poi.name',
      sortOrder: 'ASC'
    }]
  }, {
    keepPreviousData: true,
    onSuccess: function onSuccess(data) {
      if (query === null) {
        var _data$pages$flat$find, _data$pages$flat$find2;

        setQuery((_data$pages$flat$find = data === null || data === void 0 ? void 0 : (_data$pages$flat$find2 = data.pages.flat().find(function (poi) {
          return poi.id === value;
        })) === null || _data$pages$flat$find2 === void 0 ? void 0 : _data$pages$flat$find2.name) !== null && _data$pages$flat$find !== void 0 ? _data$pages$flat$find : '');
      }
    }
  }),
      poisData = _usePortalPoisPaginat.data,
      isLoadingPois = _usePortalPoisPaginat.isLoading,
      fetchNextPage = _usePortalPoisPaginat.fetchNextPage,
      isFetchingNextPage = _usePortalPoisPaginat.isFetchingNextPage,
      hasNextPage = _usePortalPoisPaginat.hasNextPage;

  var pois = (_poisData$pages$flat = poisData === null || poisData === void 0 ? void 0 : poisData.pages.flat()) !== null && _poisData$pages$flat !== void 0 ? _poisData$pages$flat : [];
  var source = pois.reduce(function (result, poi) {
    var nextResult = result;
    nextResult[poi.id] = poi.name;
    return nextResult;
  }, {});
  return isLoadingPois ? /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, {
    className: "inline-flex h-6"
  }) : /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Autocomplete, {
    className: (0, _classnames["default"])('space-x-1', className),
    inputClassName: inputClassName,
    optionRenderer: optionRenderer,
    disabled: disabled,
    icon: icon,
    label: label,
    hideLabel: hideLabel,
    value: value,
    valueType: "Integer",
    error: error,
    source: source,
    debounceTime: 400,
    filterFunction: null,
    onChange: function onChange(poiId) {
      return _onChange(pois.find(function (poi) {
        return poi.id === poiId;
      }));
    },
    onQueryChange: setQuery,
    isFetchingMore: isFetchingNextPage,
    fetchMore: fetchNextPage,
    canFetchMore: hasNextPage
  });
};

PoiFilter.defaultProps = {
  className: '',
  inputClassName: '',
  optionRenderer: undefined,
  disabled: false,
  icon: null,
  label: null,
  hideLabel: false,
  value: null,
  error: null,
  categoryIconFilters: null,
  onChange: function onChange() {}
};
var _default = PoiFilter;
exports["default"] = _default;